function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#hills_svg__clip0_2322_12486)",
  opacity: 0.5
}, React.createElement("path", {
  d: "M319 113c1.458 0 5.765-4.628 6.867-5.471 6.839-5.239 13.972-10.143 21.271-14.794C368.56 79.087 391.47 68.23 415.753 60.01c40.18-13.6 85.487-13.05 125.108 2.081 16.347 6.242 30.344 16.323 46.722 22.43 18.422 6.87 38.088 10.257 57.718 12.165 53.724 5.222 96.973-31.164 138.202-58.097 45.536-29.743 93.939-49.973 150.366-47.363C1012.77-5.125 1086.58 45.328 1120 113H319z",
  fill: "url(#hills_svg__paint0_linear_2322_12486)"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "hills_svg__paint0_linear_2322_12486",
  x1: 719.5,
  y1: -15.595,
  x2: 719.5,
  y2: 170.95,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.401,
  stopColor: "#8ADEA1"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), React.createElement("clipPath", {
  id: "hills_svg__clip0_2322_12486"
}, React.createElement("path", {
  d: "M0 0h1120v101c0 6.627-5.37 12-12 12H0V0z",
  fill: "#fff"
})));

var SvgHills = function SvgHills(props) {
  return React.createElement("svg", _extends({
    width: 1120,
    height: 113,
    viewBox: "0 0 1120 113",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='1120' height='113' viewBox='0 0 1120 113' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cg opacity='0.5'%3E %3Cg clip-path='url(%23clip0_2322_12486)'%3E %3Cpath d='M319 113C320.458 113 324.765 108.372 325.867 107.529C332.706 102.29 339.839 97.3858 347.138 92.7348C368.56 79.0874 391.47 68.2301 415.753 60.0099C455.933 46.4096 501.24 46.9594 540.861 62.0914C557.208 68.333 571.205 78.4142 587.583 84.5205C606.005 91.3912 625.671 94.7781 645.301 96.6861C699.025 101.908 742.274 65.5224 783.503 38.5893C829.039 8.84561 877.442 -11.3843 933.869 -8.77365C1012.77 -5.12514 1086.58 45.3277 1120 113H319Z' fill='url(%23paint0_linear_2322_12486)'/%3E %3C/g%3E %3C/g%3E %3Cdefs%3E %3ClinearGradient id='paint0_linear_2322_12486' x1='719.5' y1='-15.5946' x2='719.5' y2='170.95' gradientUnits='userSpaceOnUse'%3E %3Cstop offset='0.401042' stop-color='%238ADEA1'/%3E %3Cstop offset='1' stop-color='white' stop-opacity='0'/%3E %3C/linearGradient%3E %3CclipPath id='clip0_2322_12486'%3E %3Cpath d='M0 0H1120V101C1120 107.627 1114.63 113 1108 113H0V0Z' fill='white'/%3E %3C/clipPath%3E %3C/defs%3E %3C/svg%3E";
export { SvgHills as ReactComponent };